// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';

export const LaunchDarklyGlyph = (props: ComponentProps<'svg'>) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g transform="matrix(0.11111112 0 0 0.11111112 -0 0.058888756)">
			<path
				d="M109.8 214.94C 107.997055 214.91039 106.35804 213.88696 105.54 212.28C 104.73658 210.72453 104.908226 208.84428 105.98 207.45999L105.98 207.45999L156.47 137.93L68 174.11C 67.40301 174.38016 66.75528 174.51993 66.1 174.52C 64.01144 174.4985 62.179775 173.12071 61.579998 171.12001C 60.985783 169.13066 61.80725 166.99075 63.579998 165.91L63.579998 165.91L141.33 120L4.41 112.13C 1.9438841 111.9687 0.026099205 109.92138 0.026099205 107.45C 0.026099205 104.978615 1.9438841 102.9313 4.41 102.77L4.41 102.77L141.41 94.899994L63.61 49C 61.861492 47.905083 61.065918 45.772614 61.670002 43.8C 62.260277 41.79695 64.09185 40.41616 66.18 40.399998C 66.83458 40.396626 67.482346 40.532997 68.08 40.8L68.08 40.8L156.5 77L106 7.48C 104.93831 6.087954 104.76732 4.210975 105.56 2.65C 106.37893 1.0358694 108.03006 0.013560295 109.84 0C 111.078804 0.0081067085 112.26174 0.516624 113.119995 1.41L113.119995 1.41L213.77 102.05C 216.74506 105.03536 216.74506 109.86465 213.77 112.850006L213.77 112.850006L113.08 213.53C 112.22175 214.42337 111.03882 214.93188 109.8 214.94z"
				stroke="none"
				fill="#282828"
				fillRule="nonzero"
			/>
		</g>
	</svg>
);
